class TaggingIndex {
  queue = [];
  frequency = 100;
  timeout = 200 * this.frequency; // 20 seconds
  initialized = false;

  constructor() {
    this.setup();
  }

  setup() {
    window.setTimeout(() => {
      if ("utag" in window) {
        this.initialized = true;
        this.timeout = 0;
        this.process();
      }
      this.timeout -= this.frequency;
      if (this.timeout > 0) {
        this.setup();
      }
    }, this.frequency);
  }

  process() {
    if (!this.initialized) {
      return;
    }
    let action = this.queue.shift();
    while (action) {
      action();
      action = this.queue.shift();
    }
  }

  view(data) {
    Object.assign(data, { page_event: "view" });
    this.queue.push(function () {
      window.utag.view(data);
    });

    this.process();
  }

  link(data) {
    this.queue.push(function () {
      window.utag.link(data);
    });

    this.process();
  }
}

const tagging = new TaggingIndex();

export default tagging;
